module.exports = __webpack_public_path__ + "img/img-12.ac13e271.png";